import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Skeleton } from "@mui/material"
import { postExcel } from "@ui-seeker/utils"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { useToast, useUserApp } from "@hooks"
import { commonFiltersValue, isLoadingCommonFilters } from "@signals"
import { changesColumn, currentPriceColumn, diffMyPriceColumn, myPriceColumn, prevPriceColumn, retailerColumn, skuColumn } from "./columns"
import { usePricingChangesRoleConfig } from "../@hooks"
import { priceChangesTableData } from "../@signals"
import CreateReportButton from "./actions/CreateReportButton"


export default function PricingChangesTable() {
	const { isRetailerUser, isStandardUser, userUseRRSP, urlApiExcel } = usePricingChangesRoleConfig()
	const { mainSite } = useUserApp()
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	if (isLoadingCommonFilters.value)
		return <Skeleton variant="rectangular" height={500} />
	if (!priceChangesTableData.value.length)
		return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Price Changes" enabledExcel propsExcel={{
			isLoading: isLoading.value,
			onClick: () => {
				isLoading.value = true
				postExcel('/api/custom-emails/competitors/save-csv/druni', {
					...commonFiltersValue.value, retailer: mainSite,
					startDate: commonFiltersValue.value.currentSingleDate,
					endDate: commonFiltersValue.value.currentSingleDate,
					prevStartDate: commonFiltersValue.value.prevSingleDate,
					prevEndDate: commonFiltersValue.value.prevSingleDate
				})
					.finally(() => isLoading.value = false)
			}
		}}/>}
		data={priceChangesTableData.value}
		columns={[
			...retailerColumn(),
			...skuColumn(),
			prevPriceColumn(),
			currentPriceColumn(),
			...changesColumn(),
			...isRetailerUser ? [...myPriceColumn('myListPrice', 'My List Price')] : [],
			...isRetailerUser ? [...myPriceColumn('mainPrice', 'My Current Price')] : [],
			...isStandardUser && userUseRRSP ? [...myPriceColumn('rrsp', 'RRSP')] : [],
			...isRetailerUser ? [diffMyPriceColumn('diffMyPrice', 'Diff vs My Current Price', 'mainPrice')] : [],
			...isStandardUser && userUseRRSP ? [diffMyPriceColumn('diffMyPrice', 'Diff vs RRSP', 'rrsp')] : [],
		]}
		options={{
			onDownload: () => showToast.promiseExcel(urlApiExcel, {
				startDate: commonFiltersValue.value.currentSingleDate,
				endDate: commonFiltersValue.value.currentSingleDate,
				prevStartDate: commonFiltersValue.value.prevSingleDate,
				prevEndDate: commonFiltersValue.value.prevSingleDate
			}),
			customToolbar: () => <CreateReportButton />
		}}
	/>
}